/*
 * @Author: Yehon He 1427749162@qq.com
 * @Date: 2025-02-16 18:46:54
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-03-15 18:23:18
 * @FilePath: \ecloud-web\packages\mall-cook-platform\src\api\material.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'

export const getCategories = async data =>
    request({url: '/categories', method: 'GET', params:data})

export const getSubCategories = async data =>
    request({url: '/subcategories', method: 'GET', params:data})

export const saveSubcategories = async (method,data) => 
    request({url: '/subcategories', method: method, data})

export const delSubcategories = async data => 
    request({url: '/subcategories', method: 'DELETE', params:data})

export const getMaterials = async data =>
    request({url: '/materials', method: 'GET', params:data})

export const saveMaterials = async (method,data) => 
    request({url: '/materials', method: method, data})

export const delMaterials = async data => 
    request({url: '/materials', method: 'DELETE', params:data})

// 微站模块
export const getSiteTypeList = async data =>
    request({url: '/site/list', method: 'GET', params:data})

export const saveSiteType = async (isAdd,data) => {
    const url = isAdd ? 'add':'edit';
    return request({url: `/site/${url}`, method: 'POST', data})
}

export const delSiteType = async data => 
    request({url: '/site/delete', method: 'POST', data})

// 微站分类模块
export const getSiteSortList = async data =>
    request({url: '/siteSort/list', method: 'GET', params:data})

export const saveSiteSortType = async (isAdd,data) => {
    const url = isAdd ? 'add':'edit';
    return request({url: `/siteSort/${url}`, method: 'POST', data})
}

export const delSiteSortType = async data => 
    request({url: '/siteSort/delete', method: 'POST', data})

export const getShareSetting = async data => 
    request({url: '/site/share/setting/query', method: 'GET', params:data})

export const setShareSetting = async data => 
    request({url: '/site/share/setting/createOrUpdate', method: 'POST', data})

// 查询站点门票开关状态
export const getSiteTicketStatus = async data => {
    console.log('发送获取站点门票状态请求，参数:', data);
    return request({url: '/site/ticket/status', method: 'GET', params: data});
}

// 更新站点门票开关状态
export const updateSiteTicketStatus = async data => {
    console.log('发送更新站点门票状态请求，参数:', data);
    return request({url: '/site/ticket/update', method: 'POST', data});
}

// 门票模块
export const ticketList = async data => {
    console.log('发送获取门票列表请求:', data);
    return request({url: '/live/ticket/list', method: 'GET', params:data});
}

export const ticketSave = async (isAdd, data) => {
    // 深度复制对象，避免修改原对象
    const processedData = { ...data };
    
    // 确保status是数字类型
    if (processedData.status !== undefined) {
        // 统一处理各种可能的状态值，确保正确转换
        const statusValue = processedData.status;
        processedData.status = 
            statusValue === true || 
            statusValue === 'true' || 
            statusValue === 1 || 
            statusValue === '1' ? 1 : 0;
        
        console.log('门票状态值转换:', statusValue, ' -> ', processedData.status);
    }
    
    // 确保价格和数量是数字类型
    if (processedData.ticketPrice !== undefined) {
        processedData.ticketPrice = parseFloat(processedData.ticketPrice) || 0;
    }
    
    if (processedData.ticketQuantity !== undefined) {
        processedData.ticketQuantity = parseInt(processedData.ticketQuantity, 10) || 0;
    }
    
    console.log(`发送${isAdd ? '添加' : '编辑'}门票请求:`, processedData);
    
    const url = isAdd ? '/live/ticket/add' : '/live/ticket/edit';
    return request({url, method: 'POST', data: processedData});
}

export const ticketDelete = async data => {
    console.log('发送删除门票请求:', data);
    return request({url: '/live/ticket/delete', method: 'POST', data});
}

export const ticketView = async data => {
    console.log('发送查看门票详情请求:', data);
    return request({url: '/live/ticket/view', method: 'GET', params:data});
}

// 获取门票购买用户列表
export const getTicketUsers = (params) => {
  console.log('获取门票购买用户列表参数:', params);
  return request({
    url: '/live/ticket/users',
    method: 'get',
    params
  });
};

// 直播模块
export const getLiveTypeList = async data =>
    request({url: '/sort/list', method: 'GET', params:data})

export const saveLiveType = async (isAdd,data) => {
    const url = isAdd ? 'add':'edit';
    return request({url: `/sort/${url}`, method: 'POST', data})
}
export const delLiveType = async data => 
    request({url: '/sort/delete', method: 'POST', data})

export const getLiveList = async data =>
    request({url: '/room/list', method: 'GET', params:data})

// 获取直播详情
export const getLiveDetail = async data =>
    request({url: '/room/view', method: 'GET', params:data})

export const saveLive = async (data) => {
    const url = data.id == null ? 'add':'edit';
    return request({url: `/room/${url}`, method: 'POST', data})
}

export const delLive = async data => 
    request({url: '/room/delete', method: 'POST', data})

// 检查直播间状态
export const checkLiveRooms = async data =>
    request({url: '/room/checkRooms', method: 'POST', data})

// 获取表单列表
export const getFormList = async data => {
    // 确保传递skip_auth=1参数
    const params = { ...data, skip_auth: 1 };
    return request({url: '/form/form_list', method: 'GET', params});
}

// 测试用API - 直接查询门票
export const testQueryTickets = async data => {
    console.log('发送测试查询门票请求:', data);
    return request({url: '/live/ticket/test-query', method: 'GET', params:data});
}

// 增强型表单关联门票查询
export const enhancedFormTickets = async data => {
    console.log('发送增强型表单关联门票查询:', data);
    return request({url: '/live/ticket/list-by-form-enhanced', method: 'GET', params:data});
}

// 发送直播间通知（使用任务队列）
export const sendNotificationToAll = async data => {
    console.log('发送直播间通知请求（任务队列）:', data);
    
    try {
        // 首先创建通知任务
        const { status, message, data: taskData } = await request({
            url: '/notification/create-notification-task', 
            method: 'POST', 
            data: {
                roomId: data.roomId,
                type: 'notification',
                priority: data.priority || 0  // 修改为数字类型，默认为0
            }
        });
        
        if (status !== '10000') {
            throw new Error(message || '创建通知任务失败');
        }
        
        const taskId = taskData.taskId;
        console.log('通知任务已创建，任务ID:', taskId);
        
        // 返回任务ID，前端可以轮询任务状态
        return {
            status: '10000',
            message: '通知任务已创建，正在处理中',
            data: {
                taskId,
                // 提供查询任务状态的方法
                queryStatus: async () => {
                    const { status: queryStatus, message: queryMessage, data: statusData } = await request({
                        url: `/notification/task-status/${taskId}`,
                        method: 'GET'
                    });
                    
                    return {
                        status: queryStatus,
                        message: queryMessage,
                        data: statusData
                    };
                }
            }
        };
    } catch (error) {
        console.error('创建通知任务失败:', error);
        
        // 如果任务队列系统不可用，回退到原来的同步方式
        console.log('回退到同步通知发送方式');
        return request({
            url: '/notification/send-notification-to-all', 
            method: 'POST', 
            data
        });
    }
}